<div class="annotations-top-bar" *ngIf="!classificationIsActive">
    <div>
        <span class="" style="margin-right: 15px;"><img *ngIf="!annotationsTopBarIsOpen"
                src="../../assets/icon/round-add-button.svg" (click)="openAnnotationTopBar()" style="margin-top:10px">
            <img (click)="openAnnotationTopBar()" *ngIf="annotationsTopBarIsOpen"
                src="../../assets/icon/rounded-delete-button-with-minus.svg"></span>
        <button *ngIf="annotationsTopBarIsOpen" class="btn btn-primary" (click)="arrowMoveAnnotation(-1)"><img
                src="../../assets/icon/arrow-back.svg" style="margin-right: 10px;">{{previous}}</button>
        <button *ngIf="annotationsTopBarIsOpen" class="btn btn-primary" (click)="arrowMoveAnnotation(1)">{{next}}<img
                src="../../assets/icon/arrow-next.svg" style="margin-left: 10px;"></button>
        <div class="hideSelector">
            <app-select-dropdown (onSave)="editHideTypeList($event)" [list]="hideTypeList" [title]="'Masquer'"
                *ngIf="annotationsTopBarIsOpen">
            </app-select-dropdown>
        </div>

        <app-image-classification [insideClassificationImage]='false'
            *ngIf="annotationsTopBarIsOpen && currentImage !== undefined" [tchekId]='tchekId'
            [currentImage]='currentImage' [tchekPtr]='tchek'>
        </app-image-classification>

        <button *ngIf="annotationsTopBarIsOpen " class="btn btn-secondary" id="btnAnnotationActiveDamages"
            (click)="showAnnotationSelectActive('damages')"><label class="checkbox-container ">
                <input type="checkbox" [checked]="imageActiveDamages[0]" (click)="handleDamageToggleCheckbox2($event)">
                <span class="checkmark"></span></label> <span i18n="annotation|@@missingDamage">Dommage absent</span>
        </button>

        <button *ngIf="annotationsTopBarIsOpen  " class="btn btn-secondary" id="btnAnnotationActivePieces"
            (click)="showAnnotationSelectActive('pieces')"><label class="checkbox-container ">
                <input type="checkbox" [checked]="imageActiveParts[0]">
                <span class="checkmark"></span></label> <span i18n="annotation|@@missingPart">Piece
                absente</span></button>

    </div>
    <div class="annotations-box-detail" id="annotations-select-active-damages">
        <div class="damage-cardinal" *ngFor="let damage of listDamages" [hidden]=" damage === ''">

            <label class="checkbox-container ">

                <input type="checkbox" (click)="handleDamageToggleCheckbox($event, damage)"
                    [checked]="isDamageSelected(damage)">
                <span class="checkmark"></span>

            </label>

            <span class="damage-head">{{damage}}</span>
        </div>
    </div>

    <div class="annotations-box-detail" id="annotations-select-active-pieces">
        <div class="damage-cardinal" *ngFor="let piece of listPieces" [hidden]=" piece === ''">

            <label class="checkbox-container ">

                <input type="checkbox" (click)="handlePartsToggleCheckbox($event, piece)"
                    [checked]="isPartSelected(piece)">
                <span class="checkmark"></span>

            </label>

            <span class="damage-head">{{piece}}</span>
        </div>
    </div>

    <div *ngIf="annotationsTopBarIsOpen && selectedRoi && listDamagesAttributes && listPartsAttributes"
        class="annotations-box-detail" id="draggable-annotations" ngDraggable>
        <span class="number">{{selectedRoi.count}}</span>
        <div class="margin">
            <p class="ml-2">Type</p>
            <ng-select [items]="getCurrentAnnotateList()" [bindLabel]="'value'" [bindValue]="'key'"
                [(ngModel)]="selectedRoiFc[0]" [virtualScroll]='true' (change)="changeSelectedRoi($event, true)"
                [searchable]='true' notFoundText="---" [clearable]='false' placeholder='---'>
            </ng-select>
        </div>
        <div class="margin" *ngFor="let item of listAnnotateOnAttributes">
            <p class="ml-2">{{item.name}}</p>
            <ng-select [items]="item.list" [bindLabel]="'value'" [bindValue]="'key'"
                [(ngModel)]="selectedRoiFc[item.count]" [virtualScroll]='true' (change)="changeSelectedRoi($event)"
                [searchable]='true' notFoundText="---" [clearable]='false' placeholder='{{item.name}}'>
            </ng-select>
        </div>

    </div>


</div>

<div class="annotations-top-bar" *ngIf="classificationIsActive">
    <div>
        <button class="btn btn-primary" (click)="arrowMoveClassification(-1)"><img
                src="../../assets/icon/arrow-back.svg" style="margin-right: 10px;">{{previous}}</button>
        <button class="btn btn-primary" (click)="arrowMoveClassification(1)">{{next}}<img
                src="../../assets/icon/arrow-next.svg" style="margin-left: 10px;"></button>
        <button class="btn" [ngClass]="{'btn-secondary': hideDamages === false,
        'btn-primary': hideDamages === true}" (click)="hideDamagesClassification()"><span>Masquer les
                dommages</span></button>
        <button class="btn btn-secondary" id="btnAnnotationActiveDamages"
            (click)="showAnnotationSelectActive('damages')"><label class="checkbox-container ">
                <input type="checkbox" [checked]="imageActiveDamages[0]" (click)="handleDamageToggleCheckbox2($event)">
                <span class="checkmark"></span></label> Dommage absent</button>

    </div>
    <div class="annotations-box-detail" id="annotations-select-active-damages">
        <div class="damage-cardinal" *ngFor="let damage of listDamages" [hidden]=" damage === ''">

            <label class="checkbox-container ">

                <input type="checkbox" (click)="handleDamageToggleCheckbox($event, damage)"
                    [checked]="isDamageSelected(damage)">
                <span class="checkmark"></span>

            </label>

            <span class="damage-head">{{damage}}</span>
        </div>
    </div>


    <div *ngIf="damageSelected && classificationSelectedRoi && damageSelected.id" class="annotations-box-detail-small"
        ngDraggable>
        <div class="container">
            <div class="row">
                <div class="col-12"><span>Dommage id : {{damageSelected.id}}</span></div>
                <div class="col-12"><span>Nombre de Roi restant : {{damageSelected.listRoi.length}}</span>
                </div>
                <div class="col-12"><span>Roi id : {{classificationSelectedRoi.id}} </span></div>
                <div class="col-12 mt-1 mb-1 " *ngIf="listAnnotateOnAttributes">
                    <div class="m-1">
                        <span class="m-2">Type</span>
                        <ng-select [searchable]='true' [items]="listDamages" [bindLabel]="'value'" [bindValue]="'key'"
                            [(ngModel)]="damageSelectedFc[0]" [virtualScroll]='true' notFoundText="---"
                            [clearable]='false' placeholder='---' (change)='changeType($event)'>
                        </ng-select>
                    </div>
                    <div *ngFor="let item of listAnnotateOnAttributes">
                        <div class="m-1 mt-2">
                            <span class="m-2">{{item.name}}</span>
                            <ng-select [searchable]='true' [items]="item.list" [bindLabel]="'value'" [bindValue]="'key'"
                                [(ngModel)]="damageSelectedFc[item.count].key" [virtualScroll]='true' notFoundText="---"
                                [clearable]='true' placeholder='---'>
                            </ng-select>
                        </div>
                    </div>
                </div>
                <div class="col-12 mt-2">
                    <span class="bestRoiFont"
                        *ngIf="classificationSelectedRoi && classificationSelectedRoi.id === damageSelected.roiPtr.id">
                        BestRoi </span>
                </div>
                <div class="col-12 mt-2" *ngIf="_classificationService.canSave && typeExist">
                    <button type="button" class="center btn btn-lg primary longSubmit mb-1"
                        (click)='saveClassification()' i18n="annotation|@@annotationButton">Annoter ce
                        Roi </button>
                    <button type="button" class="center btn btn-lg primary longSubmit mb-1"
                        (click)="skip(false, classificationStatusRoi.skipUninteresting)"
                        i18n="annotation|@@skip_no_interesting">Skip
                        (inintéressant)</button>
                    <button type="button" class="center btn btn-lg primary longSubmit mb-1"
                        (click)="skip(false, classificationStatusRoi.skipIdontknow)"
                        i18n="annotation|@@skip_dont_know">Skip (je ne sais
                        pas)</button>
                    <button type="button" class="center btn btn-lg primary longSubmit mb-1" (click)="fp()"
                        i18n="annotation|@@skip_false_positive">Faux
                        Positif</button>
                    <button type="button" class="center btn btn-lg primary longSubmit mb-1"
                        (click)="handleDamageToggleCheckbox($event, damageSelectedFc[0]); fp()"
                        i18n="annotation|@@skip_false_positive_damage_missing">Faux
                        Positif & Dommage Abs</button>
                    <button type="button" class="center btn btn-lg primary longSubmit mt-4 mb-1" (click)="skip(true)"
                        i18n="annotation|@@skip_damage">Skip le
                        dommage</button>
                </div>
            </div>
        </div>
    </div>
</div>


<button class="btn btn-light" (click)="open()" *ngIf="count() > 0" style="color:black">
    {{count() || '0'}}
</button>

<div [@openClose]="isOpen? 'open':'closed'" #drawerContent class="content">
    <div class="dismiss" (click)="close()">
        <i class="fa fa-times" aria-hidden="true"></i>
    </div>
    <div class="header">
        <span class="title" i18n="roi_drawer|@@automatic_rois">ALL ANNOTATIONS</span>
        <span class="count">{{count() || '0'}} <span i18n="roi_drawer|@@items">items</span></span>
    </div>
    <div class="body">
        <div *ngIf="count() > 0; else noRois">
            <ul class="list-group list-group-flush">
                <li class="list-group-item no-selection">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <app-select-dropdown (onSave)="editListCheckbox($event)" [list]="activeAnnotationType"
                                    [title]="'Filtres'"></app-select-dropdown>
                            </div>
                        </div>
                    </div>
                </li>
                <li class="list-group-item no-selection unsettled"
                    [ngClass]="{'active': selectedRoi?autoRoi.id === selectedRoi.id:false}"
                    *ngFor="let autoRoi of autoRoisSearch" (click)="handleListItemClick($event, autoRoi.id)">
                    <div class="row" (click)='redirectToAnnotation(autoRoi)'>
                        <div class="col-2"><i class="fa fa-circle-o" aria-hidden="true"></i></div>
                        <div class="col-9">
                            <span class=" type">{{autoRoi.get('label')?autoRoi.get('label'):'-'}}</span>
                            <span class="location" style="margin-left: 10px;margin-right: 10px;">|</span>
                            <span *ngFor="let item of autoRoi.get('attributes')" class=" location">
                                {{item.name}} -> {{item.value}}
                            </span>
                            <span class="location" style="margin-left: 10px;margin-right: 10px;">|</span>
                            <span
                                class="location">{{autoRoi.get('userPtr')?autoRoi.get('userPtr').get("username"):'-'}}</span>
                            <span class="d-block location">{{autoRoi.get('updatedAt') | date:'medium':'fr-FR'}}</span>
                        </div>
                        <div class="col-1">
                            <!---->
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <div class="footer">
        <button class="btn btn-info btn-lg btn-block" (click)="onAnnotated.emit()">
            <span i18n="annotation|@@button_annotated">Noter ce Tchek comme annoté</span> <span
                *ngIf="isAnnotated">✓</span></button>
        <button class="btn btn-secondary btn-lg btn-block" (click)="onValidation.emit()"> <span
                i18n="annotation|@@add_scan_picture">Ajouter les images de ce scan dans l'ensemble de validation </span>
            <span *ngIf="forValidation">✓</span></button>
    </div>
</div>

<ng-template #noRois>
    <div class="mx-auto text-muted text-center" style="font-size:2em;"
        i18n="roi_drawer|@@no_automatic_rois_from_camera">
        No annotations.
    </div>
</ng-template>


// WEBPACK FOOTER //
// ./src/app/element/annotation-drawer/annotation-drawer.component.html